import { render, staticRenderFns } from "./LandingpageCard.vue?vue&type=template&id=18bfd746&scoped=true&"
import script from "./LandingpageCard.vue?vue&type=script&lang=js&"
export * from "./LandingpageCard.vue?vue&type=script&lang=js&"
import style0 from "./LandingpageCard.vue?vue&type=style&index=0&id=18bfd746&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bfd746",
  null
  
)

export default component.exports